<template>
  <div class="content has-text-centered">
    <div v-if="status == 'cancel' || status == 'false' || status == 'prepared' || isEmptyQuery">
      <failed :reason="failureReason"></failed>
    </div>
    <div v-if="status != 'cancel' && status != 'false' && status != 'prepared' && !isEmptyQuery">
      <success></success>
    </div>
  </div>
</template>

<script>
import Success from './Success'
import Failed from './Failed'

export default {
  components: {
    Success,
    Failed,
  },
  data() {
    return {
      status: '',
      title: '',
      failureReason: '',
      isEmptyQuery: false
    }
  },
  mounted() {
    this.title = this.$t('method_deposit_status', { method: 'Bitcoin' })
    // Check for both 'bitcoinpay-status' and 'confirmo-status' query parameters to determine the status
    this.isEmptyQuery = Object.keys(this.$route.query).length === 0
    this.status = this.$route.query['bitcoinpay-status'] || this.$route.query['confirmo-status']
    // Set the failure reason based on the status
    if (this.status === 'cancel' || this.status === 'prepared' || this.isEmptyQuery) {
      this.failureReason = this.$t('cancelled')
    } else if (this.status === 'false') {
      this.failureReason = this.$t('error')
    }
  },
  methods: {},
  watch: {
    // watcher for the i18n language change
    '$i18n.locale'() {
      if (this.status === 'cancel' || this.status === 'prepared' || this.isEmptyQuery) {
        this.failureReason = this.$t('cancelled')
      } else if (this.status === 'false') {
        this.failureReason = this.$t('error')
      }
    },
  },
}
</script>
